import { useState, useEffect } from "react";

// Small reusable KPI stat card
export function StatCard({ label, value, icon: Icon, accent = "text-primary", sub, testid }) {
  return (
    <div className="rounded-xl border border-border bg-card p-5 card-hover" data-testid={testid}>
      <div className="flex items-start justify-between">
        <div>
          <p className="eyebrow text-muted-foreground">{label}</p>
          <p className="mt-2 text-3xl font-heading font-extrabold tracking-tight">{value}</p>
          {sub && <p className="mt-1 text-xs text-muted-foreground">{sub}</p>}
        </div>
        {Icon && (
          <div className={`w-11 h-11 rounded-lg bg-accent flex items-center justify-center ${accent}`}>
            <Icon size={22} />
          </div>
        )}
      </div>
    </div>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl lg:text-3xl font-heading font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-1 text-sm">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}

export function useFetch(fn, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    let alive = true;
    setLoading(true);
    fn().then((d) => { if (alive) { setData(d); setLoading(false); } })
      .catch((e) => { if (alive) { setError(e?.message || "Error"); setLoading(false); } });
    return () => { alive = false; };
    // eslint-disable-next-line
  }, deps);
  return { data, loading, error, setData };
}

export function Spinner() {
  return (
    <div className="flex items-center justify-center py-24" data-testid="loading">
      <div className="w-9 h-9 rounded-full border-2 border-primary border-t-transparent animate-spin" />
    </div>
  );
}
